<template>
  <div class="badge-test-wrapper">
    <div class="badge-test-wrapper__overlay" @click="closeBadgeTest" />

    <transition name="slide">
      <div v-if="isShowing" class="badge-test">
        <div class="badge-test-toolbar">
          <div class="badge-test-toolbar__head">
            <h1>Тестирование</h1>

            <button @click="closeBadgeTest">
              <img src="/icons/close-icon-24px.svg" />
            </button>
          </div>

          <div class="badge-test-toolbar__body">
            <div class="cancel-test-data">
              <div class="badge-test-header">
                Сброс тестовых данных
              </div>

              <div class="badge-test-subheader">
                Данные добавленые через этот раздел можно удалать с вашего
                аккаунта
              </div>

              <button class="cancel-btn" @click="removeScans">
                Удалить тестовые данные
              </button>
            </div>
          </div>
        </div>

        <div class="test-badge-tabs">
          <div
            :class="tabState == 1 ? 'selected-tab-item' : ''"
            class="tab-item"
            @click="tabState = 1"
          >
            Объекты выставки
          </div>

          <div
            :class="tabState == 2 ? 'selected-tab-item' : ''"
            class="tab-item"
            @click="tabState = 2"
          >
            Гости
          </div>
        </div>

        <div class="badge-content">
          <div v-if="tabState == 1">
            <div class="first-tab">
              <div class="badge-test-header">
                Выберите объект сканирования
              </div>

              <div class="badge-test-subheader">
                В этом разделе находятся тестовые QR-коды продукции и стендов,
                штрих-коды бейджей посетителей и стендистов
              </div>

              <div class="first-tab-checkboxes">
                <div>
                  <v-checkbox
                    v-model="getEntities.isStand"
                    :hide-details="true"
                    :ripple="false"
                    label="Стенды"
                  />

                  <v-checkbox
                    v-model="getEntities.isProduct"
                    :hide-details="true"
                    :ripple="false"
                    label="Продукция"
                  />
                </div>

                <div>
                  <v-checkbox
                    v-model="getEntities.isStandman"
                    :hide-details="true"
                    :ripple="false"
                    label="Стендисты"
                  />

                  <v-checkbox
                    v-model="getEntities.isVisitor"
                    :hide-details="true"
                    :ripple="false"
                    label="Посетители"
                  />
                </div>
              </div>

              <div>
                <div class="scan-image-wrapper">
                  <div class="description">
                    {{ scanImageTitle }}
                  </div>

                  <div class="scan-image">
                    <div v-if="entityType == 'stand'" class="stand-image-top">
                      {{ entityData.title }}
                    </div>

                    <div class="img-wrapper">
                      <vue-qrcode
                        v-if="isQRCode"
                        :value="imgURL || ''"
                        :color="{ dark: '#363636', light: '#ffffff' }"
                        :width="202"
                        :margin="0"
                        type="image/png"
                      />

                      <div v-else>
                        <div class="standman-text">
                          <div class="standman-name">
                            {{ entityData.name }}
                          </div>

                          <div class="standman-company-title">
                            {{ entityData.companyTitle }}
                          </div>
                        </div>

                        <barcode v-model="barcode" />
                      </div>
                    </div>

                    <div
                      v-if="entityType == 'standman'"
                      class="standman-bottom"
                    >
                      УЧАСТНИК/EXHIBITOR
                    </div>

                    <div v-if="entityType == 'visitor'" class="visitor-bottom">
                      ПОСЕТИТЕЛЬ/VISITOR
                    </div>

                    <div
                      v-if="entityType == 'product'"
                      class="product-image-bottom"
                    >
                      <img src="/icons/product-icon-24px-white.svg" alt="" />

                      <div class="product-text">
                        <div class="product-vendor-code">
                          {{ entityData.vendorCode }}
                        </div>

                        <div class="product-title">
                          {{ entityData.title }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  class="next-btn"
                  :disabled="isBtnActive"
                  @click="getEntity"
                >
                  Следующий

                  <img src="/icons/right-arrow-icon-20px.svg" />
                </button>
              </div>
            </div>
          </div>
          <div v-if="tabState == 2">
            <div class="second-tab">
              <div class="badge-test-header">
                Выберете кого будут сканировать
              </div>
              <div class="badge-test-subheader">Эмуляция сканирований</div>
              <div class="second-tab-checkboxes">
                <v-checkbox
                  v-model="testScans.isStandman"
                  :hide-details="true"
                  :ripple="false"
                  label="Стендисты"
                />

                <v-checkbox
                  v-model="testScans.isVisitor"
                  :hide-details="true"
                  :ripple="false"
                  label="Посетители"
                />

                <v-checkbox
                  v-model="testScan.isTimeRange"
                  :hide-details="true"
                  :ripple="false"
                  label="Распределять по времени"
                />
              </div>
              <v-select
                v-model="selectedStandman"
                :items="standmans"
                item-text="text"
                class="lfs-select"
                append-icon="mdi-chevron-down"
                :menu-props="{'bottom': true, 'contentClass': 'lfs-select-menu'}"
              ></v-select>
              <button
                :disabled="isScanBtnActive"
                class="scan-btn"
                @click="testScan(1)"
              >
                Добавить 1 сканирование
              </button>
              <button
                :disabled="isScanBtnActive"
                class="scan-btn"
                @click="testScan(5)"
              >
                Добавить 5 сканирований
              </button>
              <button
                :disabled="isScanBtnActive"
                class="scan-btn"
                @click="testScan(50)"
              >
                Добавить 50 сканирований
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import VueQrcode from "vue-qrcode";
import lockBody from "@/utils/lockBody";

export default {
  name: "BadgeTest",
  components: {
    VueQrcode
  },
  computed: {
    isBtnActive() {
      return !(
        this.getEntities.isVisitor ||
        this.getEntities.isStand ||
        this.getEntities.isStandman ||
        this.getEntities.isProduct
      );
    },
    isQRCode() {
      return this.entityType == "product" || this.entityType == "stand";
    },
    scanImageTitle() {
      if (this.entityType == "visitor") return "Штрих-код посетителя";
      else if (this.entityType == "product") return "QR-код продукции";
      else if (this.entityType == "standman") return "Штрих-код стендиста";
      else return "QR-код стенда";
    },
    isScanBtnActive() {
      return !(this.testScans.isVisitor || this.testScans.isStandman);
    }
  },
  data() {
    return {
      isShowing: false, //for transition
      getEntities: {
        isVisitor: true,
        isStandman: false,
        isStand: false,
        isProduct: false
      },
      testScans: {
        isVisitor: false,
        isStandman: false,
        isTimeRange: false
      },
      tabState: 1,
      entityType: null,
      imgURL: null,
      entityData: {
        name: null
      },
      barcode: null,
      standmans: [],
      selectedStandman: null
    };
  },
  methods: {
    ...mapGetters("auth", ["showId"]),
    ...mapGetters("profile", ["profiles"]),

    closeBadgeTest() {
      this.isShowing = false;

      setTimeout(() => {
        lockBody(false);
        this.$emit("close-badge-test");
      }, 300);
    },

    async getEntity() {
      this.entityData = {};
      const req = await axios({
        url: "/test/get-entity",
        method: "POST",
        data: {
          showId: this.showId(),
          is_visitor: this.getEntities.isVisitor,
          is_standman: this.getEntities.isStandman,
          is_stand: this.getEntities.isStand,
          is_product: this.getEntities.isProduct
        }
      });
      const res = req.data;
      if (res.role == "visitor") {
        this.entityType = "visitor";
        this.barcode = res.barcode;
        this.entityData.companyTitle = res.companyTitle;
        this.entityData.name = `${res.name.first} ${res.name.last}`;
      } else if (res.vendorCode) {
        this.imgURL = `https://lfqr.cc/e/${this.showId()}/p/${res._id}`;
        this.entityType = "product";
        this.entityData.vendorCode = res.vendorCode;
        this.entityData.title = res.title;
      } else if (res.role == "standman") {
        this.entityType = "standman";
        this.barcode = res.barcode;
        this.entityData.companyTitle = res.companyTitle;
        this.entityData.name = `${res.name.first} ${res.name.last}`;
      } else {
        this.imgURL = `https://lfqr.cc/e/${res._show}/s/${res.title}`;
        this.entityType = "stand";
        this.entityData.title = res.title;
      }
    },
    async testScan(count) {
      const target_id = this.selectedStandman;

      await axios({
        url: "/test/scan",
        method: "POST",
        data: {
          is_visitor: this.testScans.isVisitor,
          is_standman: this.testScans.isStandman,
          is_time_range: this.testScans.isTimeRange,
          target_id,
          count
        }
      });
    },
    async removeScans() {
      const req = await axios({
        url: "test/remove-scan",
        method: "POST",
        data: {
          target_id: this.standmans.map(standman => standman.value)
        }
      });
    }
  },
  mounted() {
    this.isShowing = true;
    this.standmans = this.profiles().map(profile => {
      return {
        value: profile._id,
        text: `${profile.name.last} ${profile.name.first} `
      };
    });
    this.selectedStandman = this.standmans[0].value;
    this.getEntity();
  }
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}
.stand-image-top {
  background: #2d9cdb;
  height: 68px;
  color: white;
  font-weight: 700;
  font-size: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scan-image {
  height: 290px;
  width: 235px;
  display: flex;
  flex-direction: column;
}
.scan-image-wrapper {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: #e6e4ea;

  margin: 20px 0px;
  padding: 57px 50px 40px 50px;

  border-radius: 8px;

  position: relative;

  .product-image-bottom {
    height: 68px;
    width: 100%;
    background: #2d9cdb;
    color: white;
    display: flex;
    padding: 14px 16px;
    align-items: center;
    img {
      height: 24px;
      margin-right: 19px;
    }
    .product-text {
      justify-content: space-between;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .product-title {
      font-size: 14px;
      line-height: 17px;
    }
    .product-vendor-code {
      font-size: 12px;
      line-height: 14px;
    }
  }
  .description {
    top: 19px;
    left: 19px;
    position: absolute;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #363636;
  }
}

.badge-test-wrapper {
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: flex-end;

  position: fixed;
  top: 0;
  left: 0;

  z-index: 100;

  &__overlay {
    height: 100%;
    width: 100%;

    background: rgba(64, 64, 64, 0.75);

    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;

    z-index: 110;
  }
}
.badge-test {
  max-height: 100%;
  height: 100%;
  width: 376px;

  flex-basis: 376px;
  flex-shrink: 0;

  background-color: #fff;

  opacity: 1 !important;

  overflow: hidden;
  overflow-y: auto;

  z-index: 120;
}
.badge-test-toolbar {
  background: #2d9cdb;

  padding: 20px;

  &__head {
    display: flex;
    justify-content: space-between;

    margin-bottom: 18px;

    h1 {
      font-size: 20px;
      line-height: 24px;
      letter-spacing: -0.24px;
      font-weight: bold;
      color: white;

      margin-bottom: 0;
    }
  }

  &__body {
    .cancel-test-data {
      .badge-test {
        &-header,
        &-subheader {
          color: white;
        }
      }

      .cancel-btn {
        margin-top: 20px;
        width: 100%;
        background: #eb5757;
        border-radius: 8px;
        color: white;
        height: 36px;

        &:hover {
          background: rgba(235, 87, 87, 0.8);
        }
      }
    }
  }
}

.first-tab {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}

.badge-test-header {
  font-size: 15px;
  line-height: 18px;
  font-weight: 500;
  color: #363636;
  margin-bottom: 6px;
}
.tab-item:hover {
  background: #efeff4;
  color: #9a99a2;
}
.badge-test-subheader {
  font-size: 14px;
  line-height: 17px;
  font-feature-settings: "tnum" on, "lnum" on;
  color: #9a99a2;
}

.test-badge-tabs {
  width: 100%;
  display: flex;
  margin: 0 0 20px 0;
  .tab-item {
    width: 50%;
    text-align: center;
    color: #9a99a2;
    border-bottom: 1px solid #e6e4ea;
    font-weight: 500;
    padding: 13px 0;
    cursor: pointer;
    width: inherit;
  }
  .selected-tab-item {
    color: #2d9cdb;
    border-bottom: 2px solid #2d9cdb;
  }

  margin-bottom: 20px;
}
.first-tab,
.second-tab {
  border-bottom: 1px solid#e6e4ea;
  width: inherit;
}

.v-input__control {
  margin: 200px 200px !important;
}
.v-menu__content {
  border-radius: 8px;
}

.v-select-list {
  padding: 0px;
}

.next-btn,
.scan-btn {
  width: 100%;
  height: 36px;
  background: #2d9cdb;
  border-radius: 8px;
  color: white;

  &:hover {
    background: rgba(45, 156, 219, 0.8);
  }
}
button.next-btn:active,
button.scan-btn:active {
  background: #2685ba;
}
button.next-btn:disabled,
button.scan-btn:disabled {
  background: #8ec6e7;
}
button.cancel-btn:active {
  background: #ba3e3e;
}
.next-btn,
.scan-btn,
.cancel-btn {
  font-weight: 500;
  font-size: 13px;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-input--selection-controls {
  margin-top: 10px;
}
input.v-input:last-child {
  margin-bottom: 20px;
}
.scan-btn {
  margin-bottom: 15px;
}
.badge-content {
  padding: 0px 21px;
}

.first-tab-checkboxes {
  display: flex;
  justify-content: center;

  div {
    width: 50%;
  }
}

.second-tab-checkboxes {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
canvas {
  width: 200px;
}
.standman-name {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #363636;
}
.standman-bottom {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  text-align: center;
  text-transform: uppercase;

  color: #ffffff;
  background: #27ae60;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.standman-company-title {
  font-size: 18px;
  line-height: 22px;
  text-align: center;
}
.visitor-bottom {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  background: #2d9cdb;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}
.button {
  outline: none;
}
</style>
